import React from 'react';

const base = {
    width: 18,
    height: 18,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round'
};

export const MailIcon = (props) => (
    <svg {...base} {...props}>
        <rect x="2" y="4" width="20" height="16" rx="3" />
        <path d="m3 7 9 6 9-6" />
    </svg>
);

export const LockIcon = (props) => (
    <svg {...base} {...props}>
        <rect x="4" y="10" width="16" height="10" rx="2" />
        <path d="M8 10V7a4 4 0 0 1 8 0v3" />
    </svg>
);

export const EyeIcon = (props) => (
    <svg {...base} {...props}>
        <path d="M1.5 12S5 5 12 5s10.5 7 10.5 7-3.5 7-10.5 7S1.5 12 1.5 12Z" />
        <circle cx="12" cy="12" r="3" />
    </svg>
);

export const EyeOffIcon = (props) => (
    <svg {...base} {...props}>
        <path d="M17.94 17.94A10.94 10.94 0 0 1 12 19c-7 0-10.5-7-10.5-7a19.4 19.4 0 0 1 4.22-5.06M9.9 4.24A10.9 10.9 0 0 1 12 5c7 0 10.5 7 10.5 7a19.5 19.5 0 0 1-2.16 3.19M14.12 14.12a3 3 0 1 1-4.24-4.24" />
        <path d="m2 2 20 20" />
    </svg>
);
